import * as React from 'react';
import { PricedAddToCartCTA } from '../../../../../components/CTAs/PricedAddToCartCTA/PricedAddToCartCTA.js';
import { useProductData } from '../../../../../../../context/product-context-hooks.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { isSubscriptionPurchase } from '../../../../../../../types/typeguards.js';

const CLAddToCartCTA = ({ className , lineItemDrafts  })=>{
    const { displayPrice  } = useProductData();
    const { state , selectors  } = useCLEcommContext();
    const isLoading = selectors.hasQueryLoading(state);
    const totalPrice = selectors.getTotalPurchasePrice(state, displayPrice);
    const { purchaseType  } = state.configurations;
    const { deliveryInterval  } = state.configurations.subscriptionPurchaseConfigurations;
    const priceInterval = isSubscriptionPurchase(purchaseType) && !!deliveryInterval ? deliveryInterval : undefined;
    return /*#__PURE__*/ React.createElement(PricedAddToCartCTA, {
        className: className,
        lineItemDrafts: lineItemDrafts,
        price: totalPrice,
        isCentAmount: false,
        priceInterval: priceInterval,
        isLoading: isLoading
    });
};

export { CLAddToCartCTA };
//# sourceMappingURL=CLAddToCartCTA.js.map
